var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296,
    height: 173,
    viewBox: "0 0 296 173",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.660156,
    y: 0.24292,
    width: 295.088,
    height: 172.135,
    rx: 9.83627,
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_481_1996)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_481_1996",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 68,
    width: 204,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.821 68.9736H47.1758V103.974H250.821V68.9736Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_481_1996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.846 90.6883C108.846 93.3454 106.338 95.2695 102.809 95.2695H94.543V78.7773H102.53C105.967 78.7773 108.381 80.6098 108.381 83.1752C108.381 84.9161 107.452 86.0155 106.06 86.6569C107.545 87.2066 108.846 88.6726 108.846 90.6883ZM98.1649 81.8009V85.3742H102.437C103.738 85.3742 104.573 84.6412 104.573 83.6334C104.573 82.6255 103.645 81.8009 102.437 81.8009H98.1649ZM102.809 92.2459C104.202 92.2459 105.224 91.4213 105.224 90.2302C105.224 89.0391 104.295 88.2145 102.809 88.2145H98.1649V92.2459H102.809Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.496 95.1778L116.738 88.6726H115.809V95.1778H112.094V78.7773H115.809V85.0993H116.738L122.31 78.7773H126.675L119.71 86.6569L127.325 95.1778H122.496Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.324 87.0234C127.324 82.0758 131.039 78.5025 136.24 78.5025C141.441 78.5025 145.156 82.0758 145.156 87.0234C145.156 91.9711 141.441 95.5444 136.24 95.5444C131.039 95.5444 127.324 91.9711 127.324 87.0234ZM141.255 87.0234C141.255 83.9083 139.212 81.8009 136.24 81.8009C133.268 81.8009 131.225 83.9083 131.225 87.0234C131.225 90.1386 133.268 92.246 136.24 92.246C139.212 92.246 141.255 90.1386 141.255 87.0234Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.368 78.7773H163.083V95.1778H159.368V88.581H151.938V95.1778H148.223V78.7773H151.938V85.2826H159.368V78.7773Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.071 95.1778V82.0757H165.312V78.7773H180.451V82.0757H174.693V95.1778H171.071Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.426 86.0156V95.1779H193.733L192.99 92.6124C192.154 93.9868 190.389 95.5444 187.696 95.5444C184.352 95.5444 181.938 93.3454 181.938 90.3219C181.938 87.2983 184.352 85.191 189.275 85.191H192.897C192.711 83.0836 191.596 81.6177 189.553 81.6177C187.882 81.6177 186.767 82.5339 186.21 83.5417L182.866 82.992C183.702 80.1517 186.581 78.5025 189.739 78.5025C193.826 78.5025 196.426 81.2512 196.426 86.0156ZM192.804 88.0313H189.367C186.581 88.0313 185.652 88.9475 185.652 90.1386C185.652 91.513 186.767 92.4292 188.624 92.4292C191.039 92.4292 192.804 90.6884 192.804 88.0313Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73 95.1778L204.972 88.6726H204.043V95.1778H200.328V78.7773H204.043V85.0993H204.972L210.544 78.7773H214.909L207.944 86.6569L215.56 95.1778H210.73Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.247 95.1778V82.0757H216.488V78.7773H231.627V82.0757H225.869V95.1778H222.247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.2 88.0313H236.827C237.198 90.5967 239.056 92.246 241.842 92.246C243.792 92.246 245.278 91.4213 246.114 90.2302L249.551 90.78C248.343 93.8952 245.093 95.5444 241.563 95.5444C236.548 95.5444 232.926 91.9711 232.926 87.0234C232.926 82.0758 236.548 78.5025 241.563 78.5025C246.579 78.5025 250.2 82.0758 250.2 86.8402C250.293 87.2983 250.2 87.6648 250.2 88.0313ZM237.105 85.191H246.3C245.65 83.1753 243.978 81.7093 241.656 81.7093C239.427 81.6177 237.662 83.0836 237.105 85.191Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1758 85.7736C47.1758 77.854 47.1758 73.8942 49.6697 71.4339C52.1636 68.9736 56.1775 68.9736 64.2053 68.9736H65.6245C73.6523 68.9736 77.6662 68.9736 80.1601 71.4339C82.654 73.8942 82.654 77.854 82.654 85.7736V87.1736C82.654 95.0932 82.654 99.053 80.1601 101.513C77.6662 103.974 73.6523 103.974 65.6245 103.974H64.2053C56.1775 103.974 52.1636 103.974 49.6697 101.513C47.1758 99.053 47.1758 95.0932 47.1758 87.1736V85.7736Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0505 94.1883C57.9644 94.1883 53.3523 88.7196 53.1602 79.6196H57.2106C57.3436 86.2988 60.3296 89.1279 62.6948 89.7113V79.6196H66.5089V85.38C68.8445 85.1321 71.2982 82.5071 72.126 79.6196H75.94C75.3043 83.1779 72.6435 85.8029 70.7513 86.8821C72.6435 87.7571 75.6741 90.0467 76.8271 94.1883H72.6287C71.727 91.4175 69.4802 89.2738 66.5089 88.9821V94.1883H66.0505Z",
    fill: "#FCFCFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_481_1996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 204,
    height: 35,
    fill: "white",
    transform: "translate(47 68.9736)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.e8fab9d46900b5263b7a522022161b8f.svg";
export { ForwardRef as ReactComponent };